import type { RoleCounts } from '../hooks/use-role-counts';

// Las tres cards del hub de /team, en el orden del juego.
// `to: null` = rol bloqueado: todavía no es su fase, la card no navega.
export type HubRole = {
  role: string;
  countKey: keyof RoleCounts;
  to: string | null;
};

export const HUB_ROLES: HubRole[] = [
  { role: 'collector', countKey: 'collectors', to: '/team/collectors' },
  { role: 'approacher', countKey: 'approachers', to: '/team/approachers' },
  { role: 'mago', countKey: 'magos', to: null },
];
